import DashboardScreen from './index';

const routes = [
  {
    path: '/',
    component: DashboardScreen,
    action: ['read_only'],
    service: ['nvo.tms.delivery', 'nvo.tms.manifest'],
  },
];

export default routes;
